export enum VerifyStep {
  Welcome = 0,
  Info = 1,
  Code = 2,
}

export type CustomerSubmit = {
  first_name: string
  last_name: string
  email: string
  phone: string
  skip_phone_verification: boolean
}
